import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { DefaultPan } from 'api/traps/FeromonTraps/types';
import { DefaultPlan } from 'api/traps/Hubs/types';
import './LinkCell.scss';

interface LinkCellProps {
  data: DefaultPan | null | DefaultPlan;
  icon: string;
  slug: string | undefined;
}
const LocationLinkCell: React.FC<LinkCellProps> = ({ data, icon, slug }) => {
  const { t } = useTranslation();

  const link = `/object/interactive-map/${slug}?openLocationModal=true`;
  const is_warning = data ? !data?.on_plan : true;

  return (
    <Link to={link} className={`link-cell-item ${is_warning ? 'bg-warning' : ''}`}>
      <div className="icon">
        <i className={`${icon} icon rounded-pill fs-14 me-1`} />
      </div>

      <div className="text w-100 d-flex align-items-center justify-content-center">
        <span>{t('TrapTables.NotLocationAdded') || 'None'}</span>
      </div>
    </Link>
  );
};

export default LocationLinkCell;
